import React from 'react';
import RHProfilePhoto from './RHProfilePhoto';
import { getRHUserValue, getRHUserName, formatRHDate, formatRHStatus } from '../utils/rhFormatters';

function MyRHSummaryBand({ user = {}, absenceBalance, nextAbsence }) {
  const photo = getRHUserValue(user, 'photoUrl', 'photo_url', 'avatar');

  return (
    <section className="rh-summary-band" aria-label="Synthèse du profil RH">
      <div className="rh-summary-band__identity">
        <RHProfilePhoto user={user} photo={photo} />
        <div>
          <h1>{getRHUserName(user)}</h1>
          <p>{getRHUserValue(user, 'jobTitle', 'job_title', 'role') || 'Fonction non renseignée'}</p>
          <span className="rh-status-badge">{formatRHStatus(getRHUserValue(user, 'status')) || 'Actif'}</span>
        </div>
      </div>
      <dl className="rh-summary-band__facts">
        <div><dt>Contrat</dt><dd>{getRHUserValue(user, 'contractType', 'contract_type', 'contract') || '-'}</dd></div>
        <div><dt>Arrivée</dt><dd>{formatRHDate(getRHUserValue(user, 'arrivalDate', 'arrival_date', 'startDate'))}</dd></div>
        <div><dt>Responsable</dt><dd>{getRHUserValue(user, 'managerName', 'manager_name') || '-'}</dd></div>
        <div><dt>Établissement</dt><dd>{getRHUserValue(user, 'establishment', 'agency') || '-'}</dd></div>
        {absenceBalance !== undefined && <div><dt>Solde</dt><dd>{absenceBalance} j</dd></div>}
        {nextAbsence && <div><dt>Prochaine absence</dt><dd>{nextAbsence}</dd></div>}
      </dl>
    </section>
  );
}

export default MyRHSummaryBand;
